import React from "react";
import { BellRing } from "lucide-react";

export const followUpState = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  const now = new Date();
  if (d < now) return "late";
  return d.toDateString() === now.toDateString() ? "today" : "future";
};

const STYLE = {
  late: "bg-rose-100 text-rose-800 dark:bg-rose-950 dark:text-rose-200",
  today: "bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-200",
  future: "bg-muted text-muted-foreground",
};

export const FollowUpBadge = ({ iso }) => {
  const st = followUpState(iso);
  if (!st) return null;
  const d = new Date(iso);
  const label = st === "late" ? "Retorno atrasado" : st === "today" ? "Retornar hoje" : "Retornar";
  return (
    <span className={`inline-flex items-center gap-1 text-[10px] font-semibold px-1.5 py-0.5 rounded ${STYLE[st]}`} data-testid="opp-followup-badge">
      <BellRing className="w-3 h-3" /> {label} · {d.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" })} {d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })}
    </span>
  );
};
